angular.module('unica_invitation_transfer.invitation_transfer_services')

.factory('InvitationTransferListService', function ($http, getBaseApiURL) {

	var invitationTransferListService = {};

	invitationTransferListService.list = function (eventId, limit, offset) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-transfer/list/' + eventId,
			data: {
				limit: limit,
				offset: offset,
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_transfers;
			}

		});

	};

	invitationTransferListService.search = function (eventId, searchData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-transfer/search/' + eventId,
			data: searchData
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_transfers;
			}

		});
	};

	invitationTransferListService.get = function (invitationTransferId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-transfer/detail/' + invitationTransferId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_transfer;
			}

		});

	};

	invitationTransferListService.getListGrouped = function (eventId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-transfer/list-grouped/' + eventId,
			data: {}
		}).then(function(result) {
			if ( result ) {
				return result.data.transfers;
			}

		});
	};


	return invitationTransferListService;
});